import { Tabs } from "antd";
import React, { useState } from "react";
import Shipping from "../components/shipping/Shipping";
import Address from "../components/shipping/Address";
import PERMISSION from "../consts/permissions";
import { useSelector } from "react-redux";

const ShippingManager = (props) => {
  const { TabPane } = Tabs;
  const { permissions } = useSelector((x) => x.auth);
  const [listPermissions, setPermissions] = useState(permissions);

  const onChange = (key) => {
    console.log(key);
  };

  return (
    <Tabs defaultActiveKey="1" onChange={onChange}>
      {listPermissions.includes(PERMISSION.Admin_Shipping_View) ? (
        <>
          <TabPane tab="Quản lý nhà vận chuyển" key="1">
            <Shipping />
          </TabPane>
        </>
      ) : null}

      {listPermissions.includes(PERMISSION.Admin_Address_View) ? (
        <>
          <TabPane tab="Địa chỉ lấy hàng" key="2">
            <Address />
          </TabPane>
        </>
      ) : null}
    </Tabs>
  );
};

export default ShippingManager;
